var giphy_viewer_default = {
  "giphyWrapper": "RiyMN",
  "giphy_player": "giAD-",
  "playIcon": "mH7Mr",
  "gifRatio": "Wo8Hx"
};
export {
  giphy_viewer_default as default
};
//# sourceMappingURL=giphy-viewer-scss.js.map
